import { Navigate, useLocation } from "react-router-dom";
import { PATHS } from "@/lib/router";
import { useAuthStore } from "@/features/auth/hooks";
import { observer } from "mobx-react-lite";
import { ROLES } from "@/lib/constants/options";

// Protected route wrapper - requires authentication
export const ProtectedRoute = observer(({ children }) => {
  const { isAuthenticated, user } = useAuthStore();
  const location = useLocation();

  if (!isAuthenticated) {
    // Redirect to login if not authenticated
    return <Navigate to={PATHS.LOGIN} state={{ from: location }} replace />;
  }

  // Force password change for new users (admin-created with temp password)
  const isChangePasswordPath = location.pathname === PATHS.CHANGE_PASSWORD;
  if (user?.isNew && !isChangePasswordPath) {
    return <Navigate to={PATHS.CHANGE_PASSWORD} replace />;
  }

  const isCompanySetupPath = location.pathname === PATHS.COMPANY_SETUP;
  const isAdminRole = [ROLES.SYSTEM_ADMIN, ROLES.BUSINESS_UNIT].includes(
    user?.role,
  );
  const needsCompanySetup = Boolean(user && !isAdminRole && !user?.companyId);

  if (needsCompanySetup && !isCompanySetupPath) {
    return <Navigate to={PATHS.COMPANY_SETUP} replace />;
  }

  return children;
});
